<div class="contacts-tab">

  <div class="contacts-toolbar">
    <div class="contacts-search">
      <mat-icon>search</mat-icon>
      <input type="text" [formControl]="searchControl" placeholder="Search contacts" aria-label="Search contacts">
    </div>
    <button mat-icon-button matTooltip="Refresh" aria-label="Refresh contacts" (click)="refresh()">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <div class="contacts-loading" *ngIf="loading">
    <mat-spinner diameter="26"></mat-spinner>
  </div>

  <div class="contacts-empty" *ngIf="!loading && filtered.length === 0">
    <mat-icon>contacts</mat-icon>
    <p>{{ contacts.length ? 'No contacts match that search.' : 'No Outlook contacts found.' }}</p>
  </div>

  <ul class="contacts-list" *ngIf="!loading && filtered.length > 0">
    <li *ngFor="let contact of filtered; trackBy: trackById"
        class="contact-row"
        (appVisibleOnce)="ensurePhoto(contact)">
      <div class="contact-avatar" [class.contact-avatar--photo]="contact.photoUrl">
        <img *ngIf="contact.photoUrl; else initials" [src]="contact.photoUrl" [alt]="contact.displayName">
        <ng-template #initials><span>{{ contact.initials }}</span></ng-template>
      </div>

      <div class="contact-body">
        <div class="contact-name">{{ contact.displayName }}</div>
        <div class="contact-role" *ngIf="contact.jobTitle || contact.companyName">
          {{ contact.jobTitle }}<span *ngIf="contact.jobTitle && contact.companyName"> · </span>{{ contact.companyName }}
        </div>
        <div class="contact-links">
          <a *ngIf="contact.email" [href]="'mailto:' + contact.email" matTooltip="Send email">
            <mat-icon>mail_outline</mat-icon>{{ contact.email }}
          </a>
          <a *ngIf="contact.mobilePhone" [href]="'tel:' + contact.mobilePhone" matTooltip="Call mobile">
            <mat-icon>smartphone</mat-icon>{{ contact.mobilePhone }}
          </a>
          <a *ngIf="contact.businessPhone" [href]="'tel:' + contact.businessPhone" matTooltip="Call work">
            <mat-icon>call</mat-icon>{{ contact.businessPhone }}
          </a>
        </div>
      </div>
    </li>
  </ul>

  <div class="contacts-footer">
    <button mat-button (click)="openPhonebook()">
      <mat-icon>menu_book</mat-icon>
      <span>See all contacts in the BizCombo phonebook</span>
    </button>
  </div>

</div>
